import React, { useEffect, useState } from 'react';
import { db } from './firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';
import { useParams, useNavigate } from 'react-router-dom';

const VisualizarQuestionario = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [questionario, setQuestionario] = useState(null);

  useEffect(() => {
    const fetchQuestionario = async () => {
      const docRef = doc(db, 'questionarios', id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setQuestionario(docSnap.data());
      } else {
        console.log('No such document!');
      }
    };

    fetchQuestionario();
  }, [id]);

  return (
    <div className="container">
      {questionario ? (
        <>
          <h1>{questionario.nome ?? questionario.name}</h1>
          {questionario.questions.map((question, qIndex) => (
            <div key={qIndex} className="visualizar-question-item">
              {question.tituloBloco?.trim() && (
                <h2 className="question-block-title">{question.tituloBloco.trim()}</h2>
              )}
              <p>{question.question}</p>
              {question.type === 'text' ? (
                <input type="text" disabled placeholder="Resposta do texto" />
              ) : question.type === 'checkbox' ? (
                <div className="checkbox-answer-group preview-checkboxes">
                  {(question.options || []).map((option, oIndex) => {
                    const label = typeof option === 'string' ? option : option.text || '';
                    return (
                      <div key={oIndex} className="checkbox-answer-option">
                        <input
                          type="checkbox"
                          id={`preview_q${qIndex}_cb${oIndex}`}
                          disabled
                          className="checkbox-answer-input"
                        />
                        <label htmlFor={`preview_q${qIndex}_cb${oIndex}`}>{label}</label>
                      </div>
                    );
                  })}
                </div>
              ) : question.type === 'matrix' ? (
                <div className="matrix-question-wrapper">
                  <table className="matrix-question-table">
                    <thead>
                      <tr>
                        <th scope="col" className="matrix-corner-cell" />
                        {(question.options || []).map((option, oIndex) => {
                          const optionText = typeof option === 'string' ? option : option.text || '';
                          return (
                            <th key={oIndex} scope="col" className="matrix-col-header">
                              {oIndex + 1}. {optionText}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {(question.matrixRows && question.matrixRows.length ? question.matrixRows : ['']).map((rowLabel, rowIndex) => (
                        <tr key={rowIndex}>
                          <th scope="row" className="matrix-row-header">
                            {rowIndex + 1}. {rowLabel}
                          </th>
                          {(question.options || []).map((option, colIndex) => {
                            const optionText = typeof option === 'string' ? option : option.text || '';
                            return (
                              <td key={colIndex} className="matrix-cell">
                                <input
                                  type="radio"
                                  disabled
                                  name={`preview_q${qIndex}_row${rowIndex}`}
                                  aria-label={`${rowLabel}: ${optionText}`}
                                />
                              </td>
                            );
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <ul>
                  {(question.options || []).map((option, oIndex) => {
                    const label = typeof option === 'string' ? option : option.text || '';
                    return <li key={oIndex}>{label}</li>;
                  })}
                </ul>
              )}
            </div>
          ))}
        </>
      ) : (
        <p>Carregando questionário...</p>
      )}
      <button onClick={() => navigate('/')} style={{ backgroundColor: 'blue', color: 'white' }}>
        Voltar
      </button>
    </div>
  );
};

export default VisualizarQuestionario;
